/** @jsxImportSource theme-ui @jsxRuntime classic */

import React from 'react';

import { Box } from './Box';

import type { ReactNode } from 'react';

export const Spacer = ({
  children,
}: {
  children?: ReactNode;
}): React.JSX.Element => (
  <Box as="span" sx={{ ':not(:last-child)::after': { content: "'·'", mx: 2 } }}>
    {children}
  </Box>
);
